import { useState, useEffect } from "react";
import "./PlanExpiredPopup.css";
import { SuccessAlertPlan } from "../../../pages/MyProfile/SuccessPopup";


export default function PlanExpiredPopup({
    isFreePlan = true,
    canExtend = true,
    extensionRequested = false,  // ← pre-set button state if already submitted
    onRequestExtend,
    onUpgrade,
    onClose,
}) {
    const [requestSent, setRequestSent] = useState(extensionRequested);
    const [loading, setLoading] = useState(false);

    // Sync if parent updates extensionRequested (e.g. store rehydrates)
    useEffect(() => {
        setRequestSent(extensionRequested);
    }, [extensionRequested]);

    const handleRequestExtend = async () => {
        if (loading || requestSent) return;
        setLoading(true);
        try {
            if (onRequestExtend) {
                await onRequestExtend();
                setRequestSent(true);
                SuccessAlertPlan("Successfully submitted. Our team will contact you shortly.");
            }
        } catch (err) {
            console.error("Failed to request plan extension:", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="pep-overlay">
            <div className="pep-card" onClick={(e) => e.stopPropagation()}>

                {/* Warning icon */}
                <div className="pep-icon-wrap">
                    <div className="pep-icon-circle">
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="27" viewBox="0 0 30 27" fill="none" className="pep-icon">
                            <path d="M19.2001 2.41931L29.2516 19.1609C30.6961 21.5655 29.9866 24.729 27.6661 26.226C26.8877 26.7313 25.9796 27.0002 25.0516 27H4.94701C2.21551 27 0 24.705 0 21.8715C0 20.913 0.259501 19.9754 0.747002 19.1609L10.8 2.41931C12.243 0.0147877 15.294 -0.721718 17.6145 0.775294C18.2566 1.1893 18.7996 1.7518 19.2001 2.41931ZM15 21C15.3979 21 15.7794 20.8419 16.0607 20.5606C16.342 20.2793 16.5 19.8978 16.5 19.4999C16.5 19.1021 16.342 18.7206 16.0607 18.4393C15.7794 18.158 15.3979 17.9999 15 17.9999C14.6022 17.9999 14.2207 18.158 13.9394 18.4393C13.6581 18.7206 13.5 19.1021 13.5 19.4999C13.5 19.8978 13.6581 20.2793 13.9394 20.5606C14.2207 20.8419 14.6022 21 15 21ZM15 7.49985C14.6022 7.49985 14.2207 7.65788 13.9394 7.93919C13.6581 8.2205 13.5 8.60203 13.5 8.99986V14.9999C13.5 15.3977 13.6581 15.7793 13.9394 16.0606C14.2207 16.3419 14.6022 16.4999 15 16.4999C15.3979 16.4999 15.7794 16.3419 16.0607 16.0606C16.342 15.7793 16.5 15.3977 16.5 14.9999V8.99986C16.5 8.60203 16.342 8.2205 16.0607 7.93919C15.7794 7.65788 15.3979 7.49985 15 7.49985Z" fill="#E03B3F" />
                        </svg>
                    </div>
                </div>

                <h2 className="pep-title">Your Plan Has Expired</h2>

                <div className="pep-body">
                    Your Salesroute subscription has expired. To continue accessing
                    routes, reports, and customer management, please{" "}
                    {(isFreePlan && canExtend) ? "request an extension." : "upgrade your plan."}
                </div>

                {isFreePlan && canExtend ? (
                    <>
                        {/* Request Extension */}
                        <button
                            className={`pep-btn ${requestSent ? "pep-btn--sent" : "pep-btn--primary"}`}
                            onClick={handleRequestExtend}
                            disabled={loading || requestSent}
                        >
                            {loading ? (
                                <span className="pep-spinner" />
                            ) : requestSent ? (
                                <>
                                    Request Sent&nbsp;
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                        strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                        <polyline points="20 6 9 17 4 12" />
                                    </svg>
                                </>
                            ) : (
                                "Request to Extend Plan"
                            )}
                        </button>

                        {/* 🔥 Upgrade Button ALSO for free plan */}
                        <button
                            className="pep-btn pep-btn--upgrade"
                            onClick={onUpgrade}
                        >
                            Upgrade Now
                        </button>
                    </>
                ) : (
                    <button
                        className="pep-btn pep-btn--upgrade"
                        onClick={onUpgrade}
                    >
                        Upgrade Now
                    </button>
                )}
            </div>
        </div>
    );
}